module.exports = __webpack_public_path__ + "static/media/Z-Fold-Brochure-PSD-Mockup.21916e54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/primus/Z-Fold-Brochure-PSD-Mockup.jpg
// module id = 435
// module chunks = 0